(function() { window.GUID_5ad62f10_8359_46a9_99ef_4468e65412bf = { getGuid: function() { return "5ad62f10-8359-46a9-99ef-4468e65412bf"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let PlayerType;
        (function (PlayerType) {
            PlayerType[PlayerType["Regular"] = 0] = "Regular";
            PlayerType[PlayerType["Spare"] = 1] = "Spare";
            PlayerType[PlayerType["SpareForDivision"] = 2] = "SpareForDivision";
        })(PlayerType = Enumeration.PlayerType || (Enumeration.PlayerType = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=PlayerType.pre.js.map
